import { Injectable } from '@angular/core';
import { CurrencyFunctionalityService } from './currency-functionality.service';

@Injectable({
  providedIn: 'root'
})
export class CommonUtilityService {

  constructor() { }

  public static formatIncome(paymentFrequency, paymentAdvance): string {
    let paymentfrequency;
    let paymentadvance;
    let income;
    if (paymentFrequency === 'M') {
      paymentfrequency = 'Monthly';
    } else if (paymentFrequency === 'Y') {
      paymentfrequency = 'Yearly';
    } else if (paymentFrequency === 'Q') {
      paymentfrequency = 'Quarterly';
    } else if (paymentFrequency === 'H') {
      paymentfrequency = 'Half-yearly';
    }
    if (paymentAdvance === 'A') {
      paymentadvance = 'In advance';
    } else if (paymentAdvance === 'B') {
      paymentadvance = 'In arrears';
    }
    income = paymentfrequency + ' / ' + paymentadvance;
    return income;
  }
  public static formatIncomeIncrease(escalationType, escalationRate) {
    let incomeIncrease;
    switch (escalationType) {
      case 'N':
        incomeIncrease = 'No';
        break;
      case 'R':
        incomeIncrease = 'RPI';
        break;
      case 'L':
        incomeIncrease = 'LPI';
        break;
      default:
        incomeIncrease = 'Fixed' + ' / ' + escalationRate + '%';
        break;
    }
    return incomeIncrease;
  }
  public static formatGuarantedPaymentPeriod(numInYear) {
    return (numInYear === 0) ? '0' : (numInYear === 1) ? '1 year' : (numInYear + ' years');
  }
  public static flattenArray(arr) {   
    return arr.reduce((acc, val) => Array.isArray(val) ? acc.concat(this.flattenArray(val)) : acc.concat(val), []); 
  }
}
